import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { API_V1_BASE } from '@config';
import { HealthOrder } from '@models/HealthOrder';

export type GetHealthOrderParams = {
  id: string;
};

export class HealthOrderApi {
  static get = async ({ id }: GetHealthOrderParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/health_orders/${encodeURIComponent(id)}`)
      .then((response) => humps(response.data) as HealthOrder);
  };
}
